import React from "react";

const CalenderThree = () => {
  return (
    <svg
      width="44"
      height="41"
      viewBox="0 0 44 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M40.9633 10.0419L34.5296 35.872C34.0714 37.8002 32.3533 39.1365 30.3678 39.1365H5.28222C2.39948 39.1365 0.337686 36.3109 1.19678 33.5427L9.23407 7.73192C9.78771 5.93737 11.4487 4.69629 13.3196 4.69629H36.8015C38.6151 4.69629 40.1233 5.80358 40.7533 7.33085C41.116 8.15177 41.1924 9.08731 40.9633 10.0419Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        opacity="0.4"
        d="M29.6445 39.1365H38.77C41.2328 39.1365 43.1609 37.0556 42.9891 34.5929L41.0991 8.59094"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5781 9.31629L19.5636 1.06909"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.3672 9.33547L32.1617 1.05005"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M13.7969 20.0457H29.0697"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M11.8906 27.6816H27.1634"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CalenderThree;
